import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundError, RedirectError } from '#src/shared/error';

import { getNewGuideUrl } from '#src/app/shared/utils/guides';

import type { NewsAndGuidesDetailsDataQuery, NewsAndGuidesDetailsDataQueryVariables } from './api.graphql';
import { NewsAndGuidesDetailsData } from './api.graphql';

export type NewsAndGuidesDetailsPageData = {
	hasGuides: boolean;
	countryCode: string;
	details: NonNullable<NewsAndGuidesDetailsDataQuery['details']>;
};

export async function getNewsAndGuidesDetailsPageData(
	{ gql: { fetch } }: UtilityContext,
	{ countryCode, locale, slug }: { countryCode: string; locale: string; slug: string },
): Promise<NewsAndGuidesDetailsPageData> {
	const newGuideUrl = getNewGuideUrl(slug);
	if (newGuideUrl) {
		throw new RedirectError({ url: newGuideUrl, permanent: true });
	}

	const { data } = await fetch<NewsAndGuidesDetailsDataQuery, NewsAndGuidesDetailsDataQueryVariables>({
		query: NewsAndGuidesDetailsData,
		variables: { countryCode, locale, slugOrId: slug },
		rejectOnError: false,
	});

	if (!data?.details) {
		throw new NotFoundError();
	}

	return {
		hasGuides: !!data.hasGuides,
		countryCode,
		details: data.details,
	};
}
